var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_ANIM_DURATION } from "./const";
import { LayerView } from "./LayerView";
var Layer = /** @class */ (function () {
    function Layer(container, renderer, option) {
        var _this = this;
        this.container = container;
        this.renderer = renderer;
        this.id = Layer._count++;
        this.active = false;
        this.View = function () {
            return (_jsx(LayerView, __assign({}, _this.option, { active: _this.active, onClose: _this.dispose, renderContent: _this.renderer })));
        };
        this.dispose = function () {
            if (_this.option.disableTransition) {
                _this.container.remove(_this);
            }
            else {
                _this.active = false;
                _this.container.render();
                setTimeout(function () {
                    _this.container.remove(_this);
                }, _this.option.transitionDuration || DEFAULT_ANIM_DURATION);
            }
            return;
        };
        this.option = __assign({}, option);
        this.active = true;
    }
    Layer._count = 1;
    return Layer;
}());
export { Layer };
